import { axiosInstance as request } from '@api/rest.service'

const api = '/progress-bar/settings'

/**
 * @description GET /progress-bar/settings/{task}
 * @returns {AxiosPromise<any>}
 */
export const GET_PROGRESS_BAR_SETTINGS = task => request.get(`${api}/${task}`)

/**
 * @description PUT /progress-bar/settings/{task}
 * @returns {AxiosPromise<any>}
 */
export const UPDATE_PROGRESS_BAR_SETTINGS = (task, payload) => request.put(`${api}/${task}`, payload)
